module.exports = __webpack_public_path__ + "img/8.5d440d28.png";